export const features = {
  favorites: true,
  comparison: false, // Deprecated - merged into favorites
  comparisonExport: false, // PDF export - future phase
  wallet: false,
  copay: false,
  affiliate: false,
  share: false,
  degraded_mode: false,
  stories: false, // Video stories section
  
  // Auto-draft enrichment system
  productEnrichment: true,  // Master toggle for auto-draft
  urlScraper: true,         // Individual enrichers
  socialEnricher: true,
  mediaEnricher: true,
  aiResearch: true,
  
  // AskCircle AI features
  askCircle: true,
  askCircleOnboarding: true,
  askCircleBooking: false, // Will enable once Calendly is integrated
  askCircleAnonymous: false, // Future feature
  
  // Gear Bundle Marketplace
  bundles: true, // Master toggle - enabled for Phase 4-6
  
  // Circle Score System
  circleScore: false, // Multi-dimensional product scoring (popularity, value, ease of use, support, ROI)
  
  // Promo Codes System
  promoCodes: false, // Vendor discount codes and exclusive deals
  
  // Best-Of Category Pages
  bestOfPages: false, // SEO-optimized "Best CRM" style pages with rankings
  
  // User Reviews System
  userReviews: true, // User-generated product reviews with moderation
  
  // Brokerages Marketplace
  brokerages: false, // Brokerage comparison and recruiting marketplace
} as const;

export type FeatureFlag = keyof typeof features;

export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  return features[flag];
};
